<template>
  <div>
    <!-- <p>{{ markersVisibility }}</p> -->
    <!-- <p>{{ markers[0] }}</p> -->
    <!-- <p>{{ centerPosition.position }}</p> -->
    <gmap-map
      :center="centerPosition.position"
      :zoom="centerPosition.zoom"
      v-bind:style="height ? 'height:' + height : ''"
    >
      <gmap-marker
        :position="m.position"
        :clickable="!!m.popupText"
        :draggable="false"
        @click="markerClick(index)"
        v-for="(m, index) in markers"
      >
        <gmap-info-window
          :opened="markersVisibility[index] === true"
          :content="m.popupText"
          @closeclick="infoWindowClose(index)"
        ></gmap-info-window>
      </gmap-marker>

    </gmap-map>
  </div>
</template>

<style scoped>
</style>

<script>
// import { GmapMap, GmapMarker } from 'vue2-google-maps'
import _ from 'underscore'
import * as VueGoogleMaps from 'vue2-google-maps'
import Vue from 'vue'
// import VueGoogleMap from 'vue2-google-maps'
const API_KEY = 'AIzaSyDDWDFo5BKfv3C-wmPmigHhpLMG5sDs8tU'
const calgaryCoordinates = { lat: 51.0486, lng: -114.0708 }

Vue.use(VueGoogleMaps, {
  // installComponents: true,
  load: {
    key: API_KEY,
    v: '3.26'               // Google Maps API version
    // libraries: 'places',   // If you want to use places input
  }
})

export default {

  /*
   * coordinates: array of coordinate objects - { lat: '...', long: '...' }
   * height: string html style - "400px"
   */
  props: [ 'coordinates', 'height' ],

  data () {
    return {
      center: calgaryCoordinates,
      statusText: '',
      markersVisibility: {}
    }
  },

  methods: {
    markerClick (index) {
      // console.log('marker clicked ', index)
      Vue.set(this.markersVisibility, index, true)
    },
    infoWindowClose (index) {
      Vue.set(this.markersVisibility, index, false)
    }
  },

  computed: {
    // http://stackoverflow.com/questions/15719951/google-maps-api-v3-auto-center-map-with-multiple-markers
    // VugGoogleMap has a setBounds that may perform this function... will investigate
    centerPosition () {
      if (!this.coordinates || this.coordinates.length === 0) {
        return {
          position: calgaryCoordinates,
          zoom: 5
        }
      }

      var latitudearray = _.pluck(this.coordinates, 'lat')
      var longitudearray = _.pluck(this.coordinates, 'long')

      latitudearray.sort(function (a, b) { return a - b })
      longitudearray.sort(function (a, b) { return a - b })

      var latdifferenece = latitudearray[latitudearray.length - 1] - latitudearray[0]
      var temp = (latdifferenece / 2).toFixed(4)
      var latitudeMid = parseFloat(latitudearray[0]) + parseFloat(temp)
      var longidifferenece = longitudearray[longitudearray.length - 1] - longitudearray[0]
      temp = (longidifferenece / 2).toFixed(4)
      var longitudeMid = parseFloat(longitudearray[0]) + parseFloat(temp)
      var maxdifference = (latdifferenece > longidifferenece) ? latdifferenece : longidifferenece
      var zoomvalue

      if (maxdifference >= 0 && maxdifference <= 0.0037) {
        zoomvalue = 17
      } else if (maxdifference > 0.0037 && maxdifference <= 0.0070) {
        zoomvalue = 16
      } else if (maxdifference > 0.0070 && maxdifference <= 0.0130) {
        zoomvalue = 15
      } else if (maxdifference > 0.0130 && maxdifference <= 0.0290) {
        zoomvalue = 14
      } else if (maxdifference > 0.0290 && maxdifference <= 0.0550) {
        zoomvalue = 13
      } else if (maxdifference > 0.0550 && maxdifference <= 0.1200) {
        zoomvalue = 12
      } else if (maxdifference > 0.1200 && maxdifference <= 0.4640) {
        zoomvalue = 10
      } else if (maxdifference > 0.4640 && maxdifference <= 1.8580) {
        zoomvalue = 8
      } else if (maxdifference > 1.8580 && maxdifference <= 3.5310) {
        zoomvalue = 7
      } else if (maxdifference > 3.5310 && maxdifference <= 7.3367) {
        zoomvalue = 6
      } else if (maxdifference > 7.3367 && maxdifference <= 14.222) {
        zoomvalue = 5
      } else if (maxdifference > 14.222 && maxdifference <= 28.000) {
        zoomvalue = 4
      } else if (maxdifference > 28.000 && maxdifference <= 58.000) {
        zoomvalue = 3
      } else {
        zoomvalue = 3
      }

      return {
        position: {
          lat: latitudeMid,
          lng: longitudeMid
        },
        zoom: zoomvalue - 1
      }
    },

    markers () {
      var markers = []
      var i
      var loc

      if (!this.coordinates) { return [] }

      for (i = 0; i < this.coordinates.length; i++) {
        loc = this.coordinates[i]

        markers.push({
          position: {
            lat: Number(loc.lat),
            lng: Number(loc.long)
          },
          popupText: loc.popupText,
          showMarker: this.markersVisibility[i]
        })
      }

      return markers
    }
  }
}
</script>



// WEBPACK FOOTER //
// GoogleMap.vue?36383c7e